export default "__VITE_ASSET__PyAppVG$__"